<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-row :class="`px-${depth.toString()}`" align="center" justify="space-between">
    <!-- groups filters -->
    <!-- <v-col cols="12">
      <span class="text--secondary">{{labels.matchType}}</span>
      <v-select v-model="query.logicalOperator" :items="labels.matchTypes" item-text="label" item-value="id" outlined single-line dense background-color="white" hide-details />
      <v-btn v-if="depth > 1" @click="remove" outlined color="secondary" small>{{labels.removeGroup}}</v-btn>
      <v-btn v-if="depth < maxDepth" @click="addGroup" outlined color="secondary" small>{{labels.addGroup}}</v-btn>
    </v-col> -->
    <!-- end groups filters -->
    <v-col cols="8">
      <v-select v-model="selectedRule" :items="rules" item-text="label" return-object outlined single-line dense background-color="white" hide-details />
    </v-col>
    <v-col class="text-right" cols="4">
      <v-btn @click="addRule" outlined color="secondary" small>{{labels.addRule}}</v-btn>
    </v-col>
    <v-col class="py-0" cols="12">
      <query-builder-children v-bind="$props" />
    </v-col>
  </v-row>
</template>
<script>
import QueryBuilderGroup from 'vue-query-builder/src/components/QueryBuilderGroup'
import VQueryBuilderRule from './VQueryBuilderRule'
export default {
  name: 'QueryBuilderGroup',
  components: {
    QueryBuilderRule: VQueryBuilderRule
  },
  extends: QueryBuilderGroup
}
</script>